(() => {
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  let opener = null;
  const closeOverlays = (restore = true) => {
    document.querySelectorAll('.rf-overlay').forEach(e => e.hidden = true);
    document.querySelectorAll('[data-rf-open]').forEach(e => e.setAttribute('aria-expanded', 'false'));
    document.documentElement.style.overflow = '';
    if (restore) opener?.focus();
  };
  const openOverlay = (id, button) => {
    closeOverlays(false);
    const panel = document.getElementById(id);
    if (!panel) return;
    opener = button;
    panel.hidden = false;
    button?.setAttribute('aria-expanded', 'true');
    document.documentElement.style.overflow = 'hidden';
    panel.querySelector('input, [role=dialog]')?.focus();
  };
  document.addEventListener('click', e => {
    const trigger = e.target.closest('[data-rf-open]');
    if (trigger) openOverlay(trigger.dataset.rfOpen, trigger);
    if (e.target.closest('[data-rf-close],[data-rf-anchor]')) {closeOverlays();setMega(false);}
    if (e.target.closest('[data-cart-drawer-open]')) closeOverlays(false);
    if(e.target.matches('.cart-drawer__overlay')) document.querySelector('[data-cart-drawer-close]')?.click();
    const slide = e.target.closest('[data-rf-slide]');
    const rail = document.querySelector('[data-rf-products]');
    if (slide && rail) rail.scrollBy({left: Number(slide.dataset.rfSlide) * (rail.clientWidth - 88), behavior: reduced.matches ? 'instant' : 'smooth'});
  });
  document.addEventListener('keydown', e => {
    const overlay = document.querySelector('.rf-overlay:not([hidden])');
    if (e.key === 'Escape') { closeOverlays(); setMega(false); }
    if (e.key === 'Tab' && overlay) {
      const nodes = [...overlay.querySelectorAll('button,a[href],input,select,summary,[tabindex="0"]')].filter(n => n.getClientRects().length && !n.disabled);
      const first = nodes[0], last = nodes.at(-1);
      if (e.shiftKey && document.activeElement === first) {e.preventDefault();last?.focus();}
      else if (!e.shiftKey && document.activeElement === last) {e.preventDefault();first?.focus();}
    }
  });
  const megaTrigger = document.querySelector('[data-rf-mega]');
  const mega = document.getElementById('rf-mega');
  function setMega(open) { if (!mega) return; mega.hidden = !open; megaTrigger.setAttribute('aria-expanded', String(open)); }
  megaTrigger?.addEventListener('click', () => setMega(mega.hidden));
  const navItem = megaTrigger?.closest('.rf-nav-item');
  navItem?.addEventListener('mouseenter', () => { if (matchMedia('(hover:hover)').matches) setMega(true); });
  navItem?.addEventListener('mouseleave', () => setMega(false));
  navItem?.addEventListener('focusout', e => { if (!navItem.contains(e.relatedTarget)) setMega(false); });
  document.addEventListener('click', e => {if (!e.target.closest('.rf-nav-item')) setMega(false);});
  document.querySelector('[data-rf-country]')?.addEventListener('change', e => e.target.form.requestSubmit());
  const rail = document.querySelector('[data-rf-products]');
  const updateArrows = () => {
    if (!rail) return;
    const previous = document.querySelector('[data-rf-slide="-1"]'), next = document.querySelector('[data-rf-slide="1"]');
    if (previous) previous.disabled = rail.scrollLeft < 2;
    if (next) next.disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 2;
  };
  rail?.addEventListener('scroll', updateArrows, {passive: true});
  window.addEventListener('resize', updateArrows);
  updateArrows();
  rail?.addEventListener('keydown', e => {
    if (e.target !== rail || !['ArrowLeft', 'ArrowRight'].includes(e.key)) return;
    e.preventDefault(); rail.scrollBy({left: (e.key === 'ArrowLeft' ? -1 : 1) * 250, behavior: reduced.matches ? 'instant' : 'smooth'});
  });
  let touch = null;
  rail?.addEventListener('pointerdown', e => {
    if (e.pointerType !== 'touch') return;
    const media = e.target.closest('.rf-has-second');
    if (!media) return;
    const already = media.classList.contains('rf-touch-preview');
    rail.querySelectorAll('.rf-touch-preview').forEach(n => {if (n !== media) n.classList.remove('rf-touch-preview');});
    touch = {media, x:e.clientX, y:e.clientY, moved:false, already};
    media.classList.add('rf-touch-preview');
  }, {passive:true});
  rail?.addEventListener('pointermove', e => {
    if (touch && Math.hypot(e.clientX-touch.x,e.clientY-touch.y)>8) touch.moved=true;
  },{passive:true});
  rail?.addEventListener('pointercancel', () => {if(touch)touch.moved=true;},{passive:true});
  rail?.addEventListener('click', e => {
    const media = e.target.closest('.rf-has-second');
    if (touch && touch.media === media && (!touch.already || touch.moved)) e.preventDefault();
    touch = null;
  });
  const mobile = matchMedia('(max-width:749px)');
  mobile.addEventListener('change', () => {
    if (!mobile.matches && !document.getElementById('rf-menu')?.hidden) {
      closeOverlays(false);
      document.querySelector('.rf-header .rf-wordmark')?.focus({preventScroll:true});
    }
    if (mobile.matches) setMega(false);
  });
  const setFooter = () => document.querySelectorAll('.rf-footer details').forEach(e => e.open = !mobile.matches);
  mobile.addEventListener('change', setFooter);setFooter();
  document.querySelectorAll('.rf-footer summary').forEach(e => e.addEventListener('click', event => {if (!mobile.matches) event.preventDefault();}));
  const form = document.querySelector('[data-rf-search-form]');
  let timer, aborter, requestId = 0;
  async function search() {
    const input = form.querySelector('input');
    const results = document.querySelector('.rf-search-results');
    const term = input.value.trim();
    const current = ++requestId;
    aborter?.abort();
    if (!term) { results.replaceChildren(); return; }
    aborter = new AbortController();
    results.setAttribute('aria-busy','true');
    try {
      const url = new URL(form.dataset.searchUrl + '.json', location.origin);
      url.searchParams.set('q',term);url.searchParams.set('resources[type]','product');url.searchParams.set('resources[limit]','6');
      const response = await fetch(url,{signal:aborter.signal});
      if (!response.ok) throw new Error('Search unavailable');
      const data = await response.json();
      if (current !== requestId) return;
      results.replaceChildren();
      const products = data.resources?.results?.products || [];
      for (const p of products) {
        const a=document.createElement('a');a.href=p.url;
        const imageUrl=typeof p.image==='string'?p.image:p.featured_image?.url;
        if(imageUrl){const img=document.createElement('img');img.src=imageUrl;img.alt=p.title;img.loading='lazy';a.append(img);}
        const title=document.createElement('span');title.textContent=p.title;a.append(title);results.append(a);
      }
      if (!products.length) { const p=document.createElement('p');p.textContent=form.dataset.empty;results.append(p); }
    } catch(error) {
      if (error.name === 'AbortError') return;
      const p=document.createElement('p');p.textContent=form.dataset.error;results.replaceChildren(p);
    } finally {if(current===requestId)results.removeAttribute('aria-busy');}
  }
  form?.querySelector('input')?.addEventListener('input', () => {clearTimeout(timer);timer=setTimeout(search,220);});
  form?.addEventListener('submit', e => {e.preventDefault();clearTimeout(timer);search();});
  document.addEventListener('shopify:section:load', () => {setFooter();updateArrows();});
})();
